import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiFetch, parseJsonSafe, handleUnauthorized } from '../../utils/api';

export default function InvoiceListNavigation({ id, suffix = '' }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { setError(''); }, [id]);
  const origin = location.state?.invoiceNavigation;
  if (!origin?.ids?.length) return null;
  const index = origin.ids.findIndex((value) => String(value) === String(id));
  if (index < 0) return null;
  const move = async (direction) => {
    setBusy(true); setError('');
    try {
      let nextOrigin = origin;
      let nextIndex = index + direction;
      if (nextIndex < 0 || nextIndex >= origin.ids.length) {
        if (!origin.query) return;
        const page = origin.page + direction;
        const params = new URLSearchParams({ ...origin.query, page });
        const res = await apiFetch(`/api/invoices/all?${params}`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
        const data = await parseJsonSafe(res);
        if (res.status === 401) return handleUnauthorized();
        if (!res.ok) throw new Error(data.message || 'No se pudo abrir la siguiente página');
        const ids = (Array.isArray(data) ? data : data.items || []).map((invoice) => invoice.id);
        if (!ids.length) throw new Error('No hay más facturas con estos filtros.');
        nextOrigin = { ...origin, ids, page };
        nextIndex = direction > 0 ? 0 : ids.length - 1;
      }
      navigate(`/facturas/${nextOrigin.ids[nextIndex]}${suffix}`, { replace: true, state: { invoiceNavigation: { ...nextOrigin, currentId: nextOrigin.ids[nextIndex] } } });
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <div>
    <div className="btn-group btn-group-sm" role="group" aria-label="Navegar por el listado de origen">
      <button type="button" className="btn btn-outline-secondary" disabled={busy || (index === 0 && (!origin.query || origin.page <= 1))} onClick={() => move(-1)}>← Anterior</button>
      <button type="button" className="btn btn-outline-secondary" disabled={busy || (index === origin.ids.length - 1 && (!origin.query || origin.page * origin.pageSize >= origin.total))} onClick={() => move(1)}>Siguiente →</button>
    </div>
    {error && <div className="text-danger small" role="alert">{error}</div>}
  </div>;
}
